module.exports = "/* SETTING PAGE BACKGROUND*/\r\n.page-wrap{\r\n\tmin-height: 100vh;\r\n\tbackground-image: radial-gradient(#fdfbfb, #ebedee);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main